import { createSignal } from "solid-js";
export const [playerState, setPlayerState] = createSignal();
